import {tokensForThemeProvider} from '@forecast-it/design-system';
import styled from 'styled-components';

const ref = tokensForThemeProvider.sky.ref.color;
const size = tokensForThemeProvider.sky.sys.size;

// One short label naming who is speaking, used on both sides of the conversation: the agent's name
// on Nova's card, the reply tag on the person's. They are the same kind of label and differ only in
// how deep a tint each sits on - each has to stay legible on the card it belongs to - so the shape,
// the type and the text colour live here and only the surface is passed in.
//
// Drawn from tokens rather than the design system's Pill. Pill offers four variants and none is
// this pair - its closest, `information`, is a paler surface under a brighter text, so the label sat
// in a different blue from everything around it.
export const NovaLabelChip = styled.span<{surface: string}>`
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	/* A step below the brand name and the timestamp either side of it, so the chip reads as a label
	   attached to the name rather than a second heading competing with it. */
	font-size: 10px;
	line-height: 14px;
	font-weight: 500;
	white-space: nowrap;
	border-radius: ${size.borderradius['2']};
	background: ${props => props.surface};
	color: ${ref.blue['900']};
`;
